import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { RegistrationComponent } from './auth/registration/registration.component';
import { RecoveryComponent } from './auth/recovery/recovery.component';
import { AccountSettingsComponent } from './auth/account-settings/account-settings.component';
import { HomeComponent } from './home/home.component';
import { VerificationComponent } from './auth/verification/verification.component';
import { SettingsComponent } from './settings/settings.component';
import { ConsentComponent } from './auth/consent/consent.component';
import { LogoutComponent } from './auth/logout/logout.component';
import { OAuth2SettingsComponent } from './auth/oauth2-settings/oauth2-settings.component';
import { DeveloperSettingsComponent } from './developer-settings/developer-settings.component';
import { OAuth2ClientEditComponent } from './developer-settings/oauth2-client-edit/oauth2-client-edit.component';
import { ErrorComponent } from './error/error.component';
import { ItemDetailComponent } from './item-detail/item-detail.component';
import { ServiceClientComponent } from './developer-settings/service-client/service-client.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { BgmAccountSettingsComponent } from './settings/bgm-account-settings/bgm-account-settings.component';
import { FavoriteListComponent } from './favorite-list/favorite-list.component';
import { NotFoundComponent } from './not-found/not-found.component';

export const routes: Routes = [
  {
    path: 'consent',
    component: ConsentComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'search',
    component: SearchResultsComponent
  },
  {
    path: 'registration',
    component: RegistrationComponent
  },
  {
    path: 'recovery',
    component: RecoveryComponent
  },
  {
    path: 'verification',
    component: VerificationComponent
  },
  {
    path: 'settings',
    component: SettingsComponent,
    children: [
      {
        path: 'account',
        component: AccountSettingsComponent
      },
      {
        path: 'bgm',
        component: BgmAccountSettingsComponent
      },
      {
        path: 'oauth2',
        component: OAuth2SettingsComponent
      },
      {
        path: 'developer',
        component: DeveloperSettingsComponent
      },
      {
        path: 'developer/client/:id',
        component: OAuth2ClientEditComponent
      },
      {
        path: 'developer/client/:id/service',
        component: ServiceClientComponent
      }
    ]
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: 'item/:id',
    component: ItemDetailComponent,
  },
  {
    path: 'favorites',
    component: FavoriteListComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    component: HomeComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];
